/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  margin-top: ${scale.major(1)}px;
  svg {
    margin: 0 ${scale.major(1)}px;
  }
`;
